<template>
  <section class="dbData" :id="dbName+'Data'" role="tabpanel" :aria-labelledby="dbName+'Tab'" :aria-expanded="[isFirst ? 'true' : 'false']">
    <template v-for="(record, index) in records">
      <div :key="'head'+index" class="dbData_h">
        <h2 v-if="record.title" tabindex="-1">{{ record.title }}</h2>
      </div>
      <!--情報エリア-->
      <div :key="'body'+index" class="dbData_inner">
        <!--詳細情報-->
        <table v-if="record.fields" class="g-table">
          <tr v-for="(value, name, index) in record.fields" :key="index">
            <th>{{ name }}</th>
            <td v-html="join(value)"></td>
          </tr>
        </table>
        <!--/詳細情報-->
      </div>
      <!--/情報エリア-->
    </template>
  </section>
</template>

<script>
export default {
  props: {
    dbName: { type: String, required: true },
    records: { type: Array, required: true },
    isFirst: { type: Boolean, required: true },
  },
  methods: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    }
  }
}
</script>
